export default function getPrimaryString(id) {
  switch(id) {
    case '#228B22': return 'Forest';
    case '#EE82EE': return 'Violet';
    case '#00BFFF': return 'Sky Blue';
    case '#DC143C': return 'Crimson';
    case '#DAA520': return 'Gold';
    case '#800080': return 'Purple';
    default: return 'transparent';
  }
}